// Used when neither the item nor its category has a VAT. The fiscal printer maps it to department 1.
export const DEFAULT_VAT = 10;

// Single source for the VAT an item is sold with, shared by the menu editor and the fiscal receipts
export function resolveItemVat(itemVat, categoryVat) {
	if(itemVat !== null && itemVat !== undefined) {
		return parseFloat(itemVat);
	}
	if(categoryVat !== null && categoryVat !== undefined) {
		return parseFloat(categoryVat);
	}
	return DEFAULT_VAT;
}

// Summary of a product or category VAT, as edited by VatEditor
export function vatLabel(vat, nature, inheritedVat, getString) {
	if(vat === null || vat === undefined) {
		return getString('vat_auto_x', [inheritedVat]);
	}
	const vatText = parseFloat(vat) + '%';
	return nature ? vatText + ' (' + nature + ')' : vatText;
}
